export const SUB_DOMAIN_MAPPINGS = {
	radiotaxisonline: '1dSUwo3R17HovCDA0qPb',
}
